// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"60c0425e","521":"60c0425e","703":"60c0425e","736":"60c0425e"}[chunkId] + ".chunk.css";
};